"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Accordion_1 = __importDefault(require("../../components/Accordion/Accordion"));
var Container_1 = require("../../components/Container");
var utils_1 = require("../PristupnostCookies/utils");
var utils_2 = require("./utils");
var ContentInner = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px 20px 20px 10px;\n"], ["\n  padding: 20px 20px 20px 10px;\n"])));
var NapovedaPage = function () {
    return (react_1.default.createElement(Container_1.Container, { title: "\u010Cast\u00E9 dotazy", size: "lg" },
        react_1.default.createElement(utils_1.Body, null,
            react_1.default.createElement(ContentInner, null,
                react_1.default.createElement(Accordion_1.default, { data: utils_2.faq })))));
};
exports.default = NapovedaPage;
var templateObject_1;
